export default {"src":"/_next/static/media/book-hero-bg.59912f74.svg","height":405,"width":439,"blurWidth":0,"blurHeight":0};